import { useEffect, useState } from "react";

/**
 * Theo dõi kích thước cửa sổ để xử lý responsive layout.
 * Trả về [width, height].
 */
export default function useWindowSize() {
  const [size, setSize] = useState([window.innerWidth, window.innerHeight]);

  useEffect(() => {
    const handleResize = () => setSize([window.innerWidth, window.innerHeight]);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return size;
}
